module.exports = __webpack_public_path__ + "fonts/iconfont.81983578.woff2";